import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, LabelList } from "recharts";
import ChartFrame from "@/components/ChartFrame";

const DEFAULT_COLOR = "#2563eb";

// 가입자 추이 차트 — 막대 그래프로 기간별 명확한 비교 (2026-07-22 리디자인)
// 막대 위 라벨로 호버 없이 수치 즉시 확인 가능
export default function UserTrendChart({ series, valueKey = "activeUsers", label = "활성 사용자", color = DEFAULT_COLOR }) {
  const rows = series || [];
  if (rows.length === 0) {
    return <div className="rounded-xl border border-ink-200 bg-white p-8 text-center text-sm text-ink-400">데이터 없음</div>;
  }
  const data = [...rows].reverse().map((r) => ({ bucket: r.bucketLabel || r.bucket, value: r[valueKey] || 0 }));
  const maxVal = Math.max(...data.map((d) => d.value));

  return (
    <ChartFrame base="h-44 sm:h-56" tall="h-72 sm:h-96">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 22, right: 12, left: 0, bottom: 0 }}>
          <CartesianGrid vertical={false} stroke="#f0f0ee" />
          <XAxis dataKey="bucket" tick={{ fill: "#9ca3af", fontSize: 11 }} axisLine={false} tickLine={false} tickMargin={8} />
          <YAxis tick={{ fill: "#9ca3af", fontSize: 11 }} allowDecimals={false} width={32} axisLine={false} tickLine={false} />
          <Tooltip
            cursor={{ fill: "rgba(0,0,0,0.04)" }}
            contentStyle={{ borderRadius: 10, border: "none", boxShadow: "0 8px 24px rgba(15,23,42,0.14)", fontSize: 12 }}
            formatter={(value) => [`${value}명`, label]}
          />
          <Bar dataKey="value" name={label} fill={color} opacity={0.85} radius={[4, 4, 0, 0]} maxBarSize={40}>
            {/* 막대 위 라벨 — 값이 0이거나 너무 작으면 생략 */}
            <LabelList
              dataKey="value"
              position="top"
              style={{ fill: color, fontSize: 10, fontWeight: 600 }}
              formatter={(v) => (v > 0 && maxVal > 0 && v / maxVal > 0.05 ? v : "")}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartFrame>
  );
}
